import React from "react"
import { Link } from "react-router-dom"


export default function HomePage() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="bg-dark text-light py-5 mb-5"
        style={{
          background:
            "linear-gradient(135deg, rgba(0,123,255,1) 0%, rgba(32,201,151,1) 100%)",
          minHeight: "250px",
        }}
      >
        <div className="container text-center py-5">
          <h1 className="display-4 fw-bold">Welcome to JobQ</h1>
          <p className="lead mt-3">
            Seamless job management, scheduling, and more. Optimize your
            workflow with ease!
          </p>
          <Link to="/dashboard" className="btn btn-lg btn-outline-light mt-3">
            <i className="fas fa-tachometer-alt me-2"></i>
            Go to Dashboard
          </Link>
        </div>
      </div>

      {/* Main Links Section */}
      <div className="container mb-5">
        <h2 className="mb-4 text-center">Main Sections</h2>
        <div className="row gy-4">
          {/* Dashboard */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/dashboard" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-chart-line fa-3x my-3 text-primary"></i>
                  <h5 className="card-title">Dashboard</h5>
                  <p className="card-text">View analytics and key metrics.</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Jobs */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/jobs" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-briefcase fa-3x my-3 text-success"></i>
                  <h5 className="card-title">Jobs</h5>
                  <p className="card-text">
                    Browse and manage existing jobs.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Scheduling */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/scheduling" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-calendar-alt fa-3x my-3 text-info"></i>
                  <h5 className="card-title">Scheduling</h5>
                  <p className="card-text">
                    Manage production and planning schedules.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Job Queue */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/queue" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-tasks fa-3x my-3 text-warning"></i>
                  <h5 className="card-title">Job Queue</h5>
                  <p className="card-text">
                    Track jobs awaiting processing.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Shipping Queue */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/shipping-queue" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-shipping-fast fa-3x my-3 text-danger"></i>
                  <h5 className="card-title">Shipping</h5>
                  <p className="card-text">
                    Manage outgoing shipments and logistics.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Receiving */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/receiving" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-truck-loading fa-3x my-3 text-secondary"></i>
                  <h5 className="card-title">Receiving</h5>
                  <p className="card-text">
                    Manage incoming materials and stock.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      

      {/* Admin Links Section */}
      <div className="container mb-5">
        <h2 className="mb-4 text-center">Admin Section</h2>
        <div className="row gy-4">
          {/* Parts */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/parts" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-cogs fa-3x my-3 text-primary"></i>
                  <h5 className="card-title">Parts</h5>
                  <p className="card-text">
                    Add or update part details.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Cut Sheets */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/cut-sheets" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-file-alt fa-3x my-3 text-success"></i>
                  <h5 className="card-title">Cut Sheets</h5>
                  <p className="card-text">
                    Manage instructions for material cutting.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Materials */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/materials-entry" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-cubes fa-3x my-3 text-info"></i>
                  <h5 className="card-title">Materials</h5>
                  <p className="card-text">Input new materials.</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Customers */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/customers" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-users fa-3x my-3 text-warning"></i>
                  <h5 className="card-title">Customers</h5>
                  <p className="card-text">Manage customer info.</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Purchase Orders */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/purchase-orders" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-file-invoice-dollar fa-3x my-3 text-danger"></i>
                  <h5 className="card-title">Purchase Orders</h5>
                  <p className="card-text">
                    Track and create POs.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Admin POs */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/admin-pos" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-file-contract fa-3x my-3 text-warning"></i>
                  <h5 className="card-title">Admin POs</h5>
                  <p className="card-text">
                    Non-inventory vendor POs (subscriptions, service contracts).
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Data Transfer */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/admin-data-transfer" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-database fa-3x my-3 text-secondary"></i>
                  <h5 className="card-title">Data Transfer</h5>
                  <p className="card-text">Import/export data.</p>
                </div>
              </div>
            </Link>
          </div>

          {/* User Management */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/user-management" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-user-cog fa-3x my-3 text-dark"></i>
                  <h5 className="card-title">User Management</h5>
                  <p className="card-text">
                    Create or modify user accounts.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Vendors */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/vendors" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-handshake fa-3x my-3 text-primary"></i>
                  <h5 className="card-title">Vendors</h5>
                  <p className="card-text">Manage vendor relationships.</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Assemblies */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/assemblies" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-tools fa-3x my-3 text-success"></i>
                  <h5 className="card-title">Assemblies</h5>
                  <p className="card-text">
                    Manage and organize assemblies.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* NEW: Consumables */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/consumables" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-fill-drip fa-3x my-3 text-secondary"></i>
                  <h5 className="card-title">Consumables</h5>
                  <p className="card-text">
                    Manage and track consumable items.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* NEW: Invoices */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Link to="/invoices" className="text-decoration-none">
              <div className="card h-100 text-center border-0 shadow">
                <div className="card-body">
                  <i className="fas fa-file-invoice-dollar fa-3x my-3 text-primary"></i>
                  <h5 className="card-title">Invoices</h5>
                  <p className="card-text">
                    Create and manage invoices.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
